import clsx from 'clsx'
import { MapboxMobilePositionsContext } from 'components/MapboxMap/MapboxCommon'
import { useIsMobile } from 'hooks/useIsMobile'
import { useContext } from 'react'
import { isSetPoseButtonVisible } from 'utils/setPoseUi'

import style from './SetPoseFloatingButton.module.css'

type Props = {
  laserscanActive: boolean
  setPoseMode: boolean
  setSetPoseMode: (val: boolean | ((prev: boolean) => boolean)) => void
  disabled: boolean
  localizationMode?: number
}

const SetPoseFloatingButton = ({ laserscanActive, setPoseMode, setSetPoseMode, disabled, localizationMode }: Props) => {
  const isMobile = useIsMobile()
  const positions = useContext(MapboxMobilePositionsContext)

  if (!isSetPoseButtonVisible(localizationMode, laserscanActive)) return null

  const rightPos = isMobile && positions.extra1 ? positions.extra1 + 52 : undefined

  return (
    <button
      className={clsx(style.setPoseFloatingBtn, {
        [style.setPoseFloatingBtnActive]: setPoseMode,
      })}
      onClick={() => setSetPoseMode((prev: boolean) => !prev)}
      title="Set Robot Pose"
      disabled={disabled}
      style={rightPos ? { right: rightPos } : undefined}
    >
      <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
        <path d="M6 20h12v-2h2v4H4v-4h2z" />
      </svg>
    </button>
  )
}

export default SetPoseFloatingButton
